// src/components/eventos/components/TarefasList.js
import React from 'react';

/* ---- SVG Icons ---- */
const EditIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
);
const TrashIcon = () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4h6v2" />
    </svg>
);
const CheckIcon = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const TarefasList = ({ tarefas, tarefaEditando, onEditarTarefa, onRemoverTarefa }) => {
    return (
        <div style={{ fontFamily: "'Inter', -apple-system, sans-serif" }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <span style={{ fontSize: '12px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                    Tarefas Adicionadas ({tarefas.length})
                </span>
                <span style={{ fontSize: '11px', color: '#94a3b8' }}>
                    Ordenadas por horário
                </span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', maxHeight: '500px', overflowY: 'auto', paddingRight: '4px' }}>
                {tarefas.map((tarefa, idx) => {
                    const isEditando = tarefaEditando?.id === tarefa.id;
                    const isConcluida = tarefa.status === 'concluida';
                    const isAndamento = tarefa.status === 'em_andamento';
                    return (
                        <div key={tarefa.id} style={{
                            background: isEditando ? 'rgba(37,99,235,0.05)' : isConcluida ? 'rgba(44,203,144,0.04)' : '#ffffff',
                            border: `1px solid ${isEditando ? 'rgba(37,99,235,0.2)' : isConcluida ? 'rgba(44,203,144,0.2)' : '#e2e8f0'}`,
                            borderRadius: '10px', padding: '14px',
                            opacity: isConcluida ? 0.75 : 1, transition: 'all 0.15s',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    {/* Header */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px', flexWrap: 'wrap', marginBottom: '8px' }}>
                                        <span style={{ padding: '2px 8px', borderRadius: '6px', background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.2)', color: '#7c3aed', fontSize: '11px', fontWeight: 700 }}>
                                            #{idx + 1}
                                        </span>
                                        <span style={{ fontSize: '14px', fontWeight: 700, color: '#0f172a' }}>{tarefa.titulo}</span>
                                        {isConcluida && (
                                            <span style={{ padding: '2px 8px', borderRadius: '6px', background: 'rgba(44,203,144,0.1)', border: '1px solid rgba(44,203,144,0.2)', color: '#2CCB90', fontSize: '10px', fontWeight: 700 }}>
                                                ✓ CONCLUÍDA
                                            </span>
                                        )}
                                        {isAndamento && (
                                            <span style={{ padding: '2px 8px', borderRadius: '6px', background: 'rgba(37,99,235,0.08)', border: '1px solid rgba(37,99,235,0.2)', color: '#2563eb', fontSize: '10px', fontWeight: 700 }}>
                                                EM ANDAMENTO
                                            </span>
                                        )}
                                        {isEditando && (
                                            <span style={{ padding: '2px 8px', borderRadius: '6px', background: 'rgba(37,99,235,0.08)', border: '1px solid rgba(37,99,235,0.2)', color: '#2563eb', fontSize: '10px', fontWeight: 700 }}>
                                                EDITANDO
                                            </span>
                                        )}
                                    </div>

                                    {/* Horário e duração */}
                                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '6px' }}>
                                        <span style={{ fontSize: '12px', color: '#64748b' }}>
                                            ⏰ {tarefa.horaInicio} - {tarefa.horaFim}
                                        </span>
                                        <span style={{ padding: '1px 8px', borderRadius: '6px', background: 'rgba(45,184,225,0.08)', border: '1px solid rgba(45,184,225,0.15)', color: '#2DB8E1', fontSize: '11px', fontWeight: 600 }}>
                                            {tarefa.duracao} min
                                        </span>
                                    </div>

                                    {tarefa.responsavel && (
                                        <p style={{ margin: '0 0 3px', fontSize: '12px', color: '#64748b' }}>
                                            <strong style={{ color: '#1e293b' }}>Responsável:</strong> {tarefa.responsavel}
                                        </p>
                                    )}
                                    {tarefa.local && (
                                        <p style={{ margin: '0 0 3px', fontSize: '12px', color: '#64748b' }}>
                                            <strong style={{ color: '#1e293b' }}>Local:</strong> {tarefa.local}
                                        </p>
                                    )}

                                    {/* Descrição texto */}
                                    {tarefa.descricao_tipo === 'texto' && tarefa.descricao && (
                                        <div style={{ marginTop: '8px', padding: '8px 10px', background: '#f8fafc', borderRadius: '7px', border: '1px solid #e2e8f0' }}>
                                            <p style={{ margin: 0, fontSize: '12px', color: '#64748b' }}>{tarefa.descricao}</p>
                                        </div>
                                    )}

                                    {/* Descrição lista */}
                                    {tarefa.descricao_tipo === 'lista' && tarefa.descricao_items?.length > 0 && (
                                        <div style={{ marginTop: '8px', padding: '8px 10px', background: '#f8fafc', borderRadius: '7px', border: '1px solid #e2e8f0' }}>
                                            {tarefa.descricao_items.map((item, i) => (
                                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '7px', padding: '3px 0' }}>
                                                    <span style={{ color: '#2CCB90', marginTop: '1px', flexShrink: 0 }}><CheckIcon /></span>
                                                    <span style={{ fontSize: '12px', color: '#64748b' }}>{item}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Ações */}
                                <div style={{ display: 'flex', gap: '5px', flexShrink: 0 }}>
                                    <button
                                        onClick={() => onEditarTarefa(tarefa)}
                                        disabled={isConcluida}
                                        title="Editar"
                                        style={{ width: '28px', height: '28px', borderRadius: '7px', background: 'rgba(37,99,235,0.06)', border: '1px solid rgba(37,99,235,0.15)', color: '#2563eb', cursor: isConcluida ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: isConcluida ? 0.3 : 1, transition: 'all 0.15s' }}
                                    >
                                        <EditIcon />
                                    </button>
                                    <button
                                        onClick={() => onRemoverTarefa(tarefa.id)}
                                        disabled={isConcluida}
                                        title="Remover"
                                        style={{ width: '28px', height: '28px', borderRadius: '7px', background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.15)', color: '#ef4444', cursor: isConcluida ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: isConcluida ? 0.3 : 1, transition: 'all 0.15s' }}
                                    >
                                        <TrashIcon />
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TarefasList;
